export default "__VITE_ASSET__tkuGPIAu__"